"use strict";exports.__esModule = true;exports.default = void 0;var _makeupFloatingLabel = _interopRequireDefault(require("makeup-floating-label"));function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _default =

{
  handleChange(event) {
    var selectedIndex = event.target.selectedIndex;
    var el = this.getEls('option')[selectedIndex];
    var option = this.input.options[selectedIndex];

    this.state.selectedIndex = selectedIndex;

    // TODO: we should not cast the selected value to a string here, but this is a breaking change.
    this.emit('change', {
      index: selectedIndex,
      selected: [String(option.value)],
      el });

  },

  handleFloatingLabelInit() {
    this.emit('floating-label-init');
  },

  onCreate() {
    this.state = { selectedIndex: 0 };
  },

  onInput(input) {
    var state = this.state;
    input.options = input.options || [];
    state.selectedIndex = Math.max(
    0,
    input.options.findIndex(function (option) {return option.selected;}));

  },

  onMount() {
    this._setupMakeup();
  },

  onUpdate() {
    this._setupMakeup();
  },

  _setupMakeup() {
    // TODO: makeup-floating-label should be updated so that we can remove the event listeners.
    // It probably makes more sense to just move this functionality into Marko though.
    if (this.input.floatingLabel) {
      if (this._floatingLabel) {
        this._floatingLabel.refresh();
        this.handleFloatingLabelInit();
      } else if (document.readyState === 'complete') {
        if (this.el) {
          this._floatingLabel = new _makeupFloatingLabel.default(this.el);
          this.handleFloatingLabelInit();
        }
      } else {
        this.subscribeTo(window).once('load', this._setupMakeup.bind(this));
      }
    }
  } };exports.default = _default;module.exports = exports.default;